module.exports = __webpack_public_path__ + "img/max-file-content-signature-sync.a6995a67.svg";